module.exports = __webpack_public_path__ + "officialStatic/img/solution-smart-fatory.35e1a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-smart-fatory.png
// module id = bXMT
// module chunks = 0